import { render, staticRenderFns } from "./OutcomeFilterBadge.vue?vue&type=template&id=5002c995&"
import script from "./OutcomeFilterBadge.vue?vue&type=script&lang=js&"
export * from "./OutcomeFilterBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports